(function() { module.exports = window["eventespresso"]["data"]; }());